import React from 'react';
import { Box } from '@mui/material';
import './InstructorTableSkeleton.css';

const InstructorTableSkeleton = ({ rows = 10 }) => {
  return (
    <Box className="instructor-skeleton-container">
      <table className="instructor-skeleton-table">
        <thead>
          <tr>
            <th className="instructor-skeleton-th checkbox-col">
              <Box className="instructor-skeleton-box checkbox-skeleton" />
            </th>
            <th className="instructor-skeleton-th">
              <Box className="instructor-skeleton-box header-skeleton" />
            </th>
            <th className="instructor-skeleton-th">
              <Box className="instructor-skeleton-box header-skeleton" />
            </th>
            <th className="instructor-skeleton-th">
              <Box className="instructor-skeleton-box header-skeleton" />
            </th>
            <th className="instructor-skeleton-th">
              <Box className="instructor-skeleton-box header-skeleton" />
            </th>
            <th className="instructor-skeleton-th">
              <Box className="instructor-skeleton-box header-skeleton" />
            </th>
            <th className="instructor-skeleton-th">
              <Box className="instructor-skeleton-box header-skeleton" />
            </th>
            <th className="instructor-skeleton-th">
              <Box className="instructor-skeleton-box header-skeleton" />
            </th>
            <th className="instructor-skeleton-th">
              <Box className="instructor-skeleton-box header-skeleton" />
            </th>
            <th className="instructor-skeleton-th">
              <Box className="instructor-skeleton-box header-skeleton" />
            </th>
            <th className="instructor-skeleton-th">
              <Box className="instructor-skeleton-box header-skeleton" />
            </th>
            <th className="instructor-skeleton-th">
              <Box className="instructor-skeleton-box header-skeleton" />
            </th>
          </tr>
        </thead>
        <tbody>
          {[...Array(rows)].map((_, rowIndex) => (
            <tr key={rowIndex} className="instructor-skeleton-row">
              <td className="instructor-skeleton-td checkbox-col">
                <Box className="instructor-skeleton-box checkbox-skeleton" />
              </td>
              <td className="instructor-skeleton-td">
                <Box className="instructor-skeleton-name-container">
                  <Box className="instructor-skeleton-avatar" />
                  <Box className="instructor-skeleton-box name-skeleton" />
                </Box>
              </td>
              <td className="instructor-skeleton-td">
                <Box className="instructor-skeleton-box text-skeleton" />
              </td>
              <td className="instructor-skeleton-td">
                <Box className="instructor-skeleton-badges">
                  <Box className="instructor-skeleton-badge" />
                  <Box className="instructor-skeleton-badge" />
                </Box>
              </td>
              <td className="instructor-skeleton-td">
                <Box className="instructor-skeleton-box text-skeleton" />
              </td>
              <td className="instructor-skeleton-td">
                <Box className="instructor-skeleton-box text-skeleton-short" />
              </td>
              <td className="instructor-skeleton-td">
                <Box className="instructor-skeleton-box text-skeleton-short" />
              </td>
              <td className="instructor-skeleton-td">
                <Box className="instructor-skeleton-icons">
                  <Box className="instructor-skeleton-icon" />
                  <Box className="instructor-skeleton-icon" />
                </Box>
              </td>
              <td className="instructor-skeleton-td">
                <Box className="instructor-skeleton-box text-skeleton" />
              </td>
              <td className="instructor-skeleton-td">
                <Box className="instructor-skeleton-box text-skeleton" />
              </td>
              <td className="instructor-skeleton-td">
                <Box className="instructor-skeleton-box text-skeleton" />
              </td>
              <td className="instructor-skeleton-td">
                <Box className="instructor-skeleton-badge-container">
                  <Box className="instructor-skeleton-status-badge" />
                </Box>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Box>
  );
};

export default InstructorTableSkeleton;
